var _path, _path2, _path3, _rect, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocx = function SvgDocx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 37"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E9EC",
    d: "M2.625 3.75a1.5 1.5 0 0 1 1.5-1.5h18l7.5 8.625V35.25a1.5 1.5 0 0 1-1.5 1.5h-24a1.5 1.5 0 0 1-1.5-1.5V3.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F5F6",
    stroke: "#888D96",
    strokeWidth: 0.75,
    d: "M7.125.375h17.83l7.295 8.39V33c0 .621-.504 1.125-1.125 1.125h-24A1.125 1.125 0 0 1 6 33V1.5C6 .879 6.504.375 7.125.375Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B7BBC2",
    d: "M6.375 21.75H28.5v3.75A1.5 1.5 0 0 1 27 27H6.375v-5.25Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28.5,
    height: 13.5,
    y: 12,
    fill: "#185ABD",
    rx: 1.125
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.375 15.262 1.397 2.338h.053l1.415-2.338h1.3l-1.96 3.181 1.996 3.182h-1.328l-1.423-2.32h-.053l-1.424 2.32H21.03l2.012-3.182-1.986-3.181h1.319ZM19.395 17.406c-.136-.764-.747-1.204-1.52-1.204-1.042 0-1.78.8-1.776 2.241-.004 1.464.738 2.242 1.776 2.242.755 0 1.366-.422 1.52-1.17h1.151c-.175 1.222-1.182 2.198-2.69 2.198-1.678 0-2.913-1.217-2.908-3.27-.005-2.056 1.243-3.27 2.909-3.27 1.406 0 2.492.818 2.69 2.233h-1.152ZM14.086 18.443c.005 2.057-1.252 3.27-2.918 3.27-1.674 0-2.922-1.217-2.917-3.27-.005-2.056 1.243-3.27 2.918-3.27 1.665 0 2.922 1.214 2.917 3.27Zm-4.684 0c-.005 1.455.73 2.242 1.767 2.242 1.041 0 1.77-.787 1.766-2.242.005-1.454-.725-2.24-1.767-2.24-1.037 0-1.77.786-1.766 2.24ZM4.313 21.625H2.151v-6.363h2.197c1.899 0 3.046 1.19 3.05 3.173-.004 1.99-1.151 3.19-3.085 3.19Zm-1.02-.993h.958c1.332.004 2.004-.73 2.004-2.197 0-1.46-.672-2.184-1.968-2.18h-.994v4.377Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#888D96",
    d: "M25.125 0v8.625h7.5L25.125 0Z"
  })));
};
export default SvgDocx;